import { render, staticRenderFns } from "./ProfitStatistic.vue?vue&type=template&id=53f2e5ef&scoped=true&"
import script from "./ProfitStatistic.vue?vue&type=script&lang=js&"
export * from "./ProfitStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2e5ef",
  null
  
)

export default component.exports